import React, { Component } from 'react';

class Nature extends Component {
	render() {
		return (
			<section className="nature">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-6">
							<div className="nature__content">
								<h1 className="nature__title">Balance <em>of</em><br /> Nature <em> and</em> Science</h1>
								<p className="nature__description">Natural physical exofliants (like sugar or walnut scrubs) can cause micro-tears. <br/>Clean Slate is soaked in powerful active ingredients and gentle acids (BHAs) that dissolve away your dead skin cells and impurities ever so gently while hydrating your skin for marshmallow-like skin!</p>
							</div>
						</div>
					</div>
				</div>
				<img className="nature__bg" src="/images/nature-and-science.png" alt="" />
			</section>
		);
	}
}


export default Nature;